var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductDef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.729,
    height: 16.729,
    viewBox: "0 0 16.729 16.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product-_def",
    "data-name": "Product- def",
    transform: "translate(-162 -160.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "inventory_2_FILL1_wght400_GRAD0_opsz48_2_",
    "data-name": "inventory_2_FILL1_wght400_GRAD0_opsz48 (2)",
    d: "M4.836,19.433V9.144a.9.9,0,0,1-.565-.418A1.365,1.365,0,0,1,4,7.911V5.255a1.216,1.216,0,0,1,.376-.868A1.188,1.188,0,0,1,5.255,4h14.22a1.2,1.2,0,0,1,.868.387,1.2,1.2,0,0,1,.387.868V7.911a1.365,1.365,0,0,1-.272.816.9.9,0,0,1-.565.418V19.433a1.269,1.269,0,0,1-.387.889,1.173,1.173,0,0,1-.868.408H6.091a1.161,1.161,0,0,1-.878-.408A1.287,1.287,0,0,1,4.836,19.433ZM19.475,7.911V5.255H5.255V7.911ZM9.855,13.557h5.019V12.3H9.855Z",
    transform: "translate(158 156.302)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDef);
export default __webpack_public_path__ + "static/media/product_def.ab1bc862759b3c5c2d8c5439811a3711.svg";
export { ForwardRef as ReactComponent };